import { render } from "./AdminPerformance.vue?vue&type=template&id=7dd3b9b4"
import script from "./AdminPerformance.vue?vue&type=script&lang=js"
export * from "./AdminPerformance.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/laravel/sundae-scoops/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__